import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import classnames from 'classnames'

import Icon from '../util/Icon'

function calculatePagesShown(current, total) {
  let before, after
  if (current > total - 3) {
    after = total - current
    before = Math.min(6 - after, current - 1)
  } else {
    before = Math.min(3, current - 1)
    after = Math.min(6 - before, total - current)
  }
  const pages = []
  for (let i = current - before; i < current; i++) pages.push(i)
  pages.push(current)
  for (let i = current + 1; i <= current + after; i++) pages.push(i)
  return pages
}

@observer
export default class StorePagination extends Component {
  render() {
    const { query={}, store: { currentPage, totalPages, prevPage, nextPage } } = this.props
    const numberedPages = calculatePagesShown(currentPage, totalPages)

    return (
      <div className="pagination-links">

        <Link
          className={classnames('prev', { disabled: !prevPage })}
          to={location => (prevPage ? { ...location, query: { ...location.query, ...query, page: prevPage } } : location)}>
          <Icon icon="angle-left" />
        </Link>

        {numberedPages.map(pageNum => (
          <Link
            key={`page-link-${pageNum}`}
            className={classnames('page', { current: pageNum == currentPage })}
            to={location => ({ ...location, query: { ...location.query, ...query, page: pageNum } })}>
            {pageNum}
          </Link>
        ))}

        <Link
          className={classnames('next', { disabled: !nextPage })}
          to={location => (nextPage ? { ...location, query: { ...location.query, ...query, page: nextPage } } : location)}>
          <Icon icon="angle-right" />
        </Link>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/navigation/StorePagination.js